module.exports = __webpack_public_path__ + "img/map-icon3.abde2cdf.png";